// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2IxmE","footer":"ChangeClinic_footer__1qTny"};